import React, { Component } from 'react'

export default class HeaderDownAfter extends Component
{
    render()
    {
        return (
        
            <div className="header_banner"></div>
            
        )
    }
}
